export default __webpack_public_path__ + "static/media/LIE.e21d9db1.svg";